import React from 'react';

import { GenerateListIcon } from './GenerateListIcon';
import { ListIconsProps } from './types';

export const ProductionIcon: React.FC<ListIconsProps> = ({ isProduction, size = 24, tooltipMessageKey, ...props }) =>
  isProduction ? (
    <GenerateListIcon
      {...props}
      kind="remove_from_production"
      additionalClassName="schedule-status-icon from-production"
      size={size}
      tooltipMessageKey={tooltipMessageKey || 'layout.action.removeFromProduction'}
    />
  ) : (
    <GenerateListIcon
      {...props}
      kind="put_to_production"
      additionalClassName="schedule-status-icon to-production"
      size={size}
      tooltipMessageKey={tooltipMessageKey || 'layout.action.putToProduction'}
    />
  );
